<template>
  <div>
    <h4 class="font-weight-bold pa-3 mb-0">
      Non-Resident / Returning Expert Program (REP) / Knowledge Worker (IRDA) / C Suite
      <employee-profile-payroll-payroll-company-non-resident-tax-dialog-create
        v-if="!companyEmployee.end_date && $hasPermissionTo(['update employee payroll'])"
        :company-employee-uid="companyEmployee.company_employee_uid"
        @created="$emit('load')"
      />
    </h4>

    <v-row
      v-if="companyEmployee.non_resident_taxes.length > 0"
      class="mx-0"
    >
      <v-col cols="3">
        <div class="font-weight-medium">
          Status Type
        </div>
      </v-col>
      <v-col cols="3">
        <div class="font-weight-medium">
          Payroll Period
        </div>
      </v-col>
      <v-col cols="3">
        <div class="font-weight-medium text-center">
          Percentage (%)
        </div>
      </v-col>
      <v-col cols="3" />
    </v-row> 

    <v-row
      v-else
      class="mx-0"
    >
      <v-col
        cols="12"
        class="py-0"
      >
        <span>No Data Available</span>
      </v-col>
    </v-row>

    <v-row
      v-for="(nonResidentTax,index) in companyEmployee.non_resident_taxes"
      :key="index"
      class="px-3"
      no-gutters
    >
      <v-col cols="3">
        <div>
          <v-tooltip
            bottom
            min-width="250"
          >
            <template v-slot:activator="{ on: tooltip }">
              <v-icon
                class="pr-1"
                small
                color="info"
                v-on="{ ...tooltip }"
              >
                mdi-information-outline
              </v-icon>
            </template>
            <div>Created by: <b>{{ nonResidentTax.created_by }}</b> on <b>{{ $moment(nonResidentTax.created_at).format('DD-MM-YYYY') }}</b></div>
            <div>Updated by: <b>{{ nonResidentTax.updated_by }}</b> on <b>{{ $moment(nonResidentTax.updated_at).format('DD-MM-YYYY') }}</b></div>
          </v-tooltip>

          <span v-if="nonResidentTax.status_type==='NON-RESIDENT'">Non-Resident</span>
          <span v-else-if="nonResidentTax.status_type==='REP'">Returning Expert Program (REP)</span>
          <span v-else-if="nonResidentTax.status_type==='IRDA'">Knowledge Worker (IRDA)</span>
          <span v-else-if="nonResidentTax.status_type==='C-SUITE'">C Suite</span>
          <span v-else>Others</span>
        </div>
      </v-col>
      <v-col cols="3">
        <div>
          {{ $moment(nonResidentTax.payroll_period_date).format('MMM YYYY') }}
        </div>
      </v-col>
      <v-col cols="3"> 
        <div class="text-center">
          {{ twoDigit(nonResidentTax.percentage) }}
        </div>
      </v-col>
      <v-col cols="3"> 
        <div>
          <employee-profile-payroll-payroll-company-non-resident-tax-dialog-delete
            v-if="!companyEmployee.end_date && $hasPermissionTo(['update employee payroll'])"
            :non-resident-tax="nonResidentTax"
            @deleted="$emit('load')"
          />
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  export default {
    components: {
      EmployeeProfilePayrollPayrollCompanyNonResidentTaxDialogCreate: () => import('@/components/hris/employee/profile/payroll/payroll-company/non-resident-tax/DialogCreate'),
      EmployeeProfilePayrollPayrollCompanyNonResidentTaxDialogDelete: () => import('@/components/hris/employee/profile/payroll/payroll-company/non-resident-tax/DialogDelete'),
    },
    props: {
      companyEmployee: {
        type: Object,
        default: null,
      },
    },

    methods: {
      twoDigit ($amount) {
        return (Math.round(($amount / 100) * 100) / 100).toFixed(2)
      },

    },
  }
</script>
